import React from 'react';
// GameplayerUI imports
import PlayerApp from '../../../GamePlayerUI/components/App';
// Game(kit) imports
import gameKit from '../../../GameKit';
import ButtonsContainer from './buttonscontainer';

class TestPlayer extends React.Component {
    componentDidUpdate() {
        gameKit.game.updateRenderSize();
    }

    onSnapshot = () => {
        gameKit.makeScreenshot();
    };

    render() {
        const { active } = this.props;

        return (
            <div id="test-player-overlay" className="full-height" style={active ? {} : { display: 'none' }}>
                <div className="canvas-wrapper">
                    <PlayerApp />
                    <div className="canvas-overlay">
                        <ButtonsContainer isTesting />
                    </div>
                </div>
            </div>
        );
    }
}

export default TestPlayer;
